import "core-js/modules/es.regexp.exec.js";
import React, { Suspense, lazy } from 'react';
import { BlockingErrorBoundary, ErrorNamespaceProvider } from '@edreamsodigeo/frontend-core';
const PFunnel = /*#__PURE__*/lazy(() => import(/* webpackChunkName: "profilefunnel" */
'./Funnel'));
const profileRegex = /\/travel\/profile\//;
export const ProfileFunnel = () => /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
  namespace: "shell_funnel_profile"
}, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
  name: "funnel_profile"
}, profileRegex.test(window.location.href) && /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(PFunnel, null))));